module.exports = __webpack_public_path__ + "static/media/press_content_11.cf1f87fb.png";